/**
 * Light Fingers: open it and keep walking.
 *
 * The looting equivalent of the reload-while-moving perk: it does not make you richer, it makes the
 * greedy line through a room survivable.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const LIGHT_FINGERS = {
  id: 'lightFingers',
  branch: 'scavenging',
  tier: 3,
  title: 'Light Fingers',
  blurb: 'Take only what you need. Then reconsider what you need, briefly, and take that too.',
  maxRanks: 2,
  minLevel: 17,
  requires: ['lootersInstinct'],
  statGrants: {},
  effects: [
    { field: 'interactSeconds', perRank: -0.1, condition: null },
    { field: 'moveSpeed', perRank: 0.03, condition: null },
  ],
  damageModifiers: [],
} as const satisfies Perk;
